var map = {
	"./24a94e1e.webp": 76272,
	"./5b3e7a36.webp": 6335,
	"./7ece7b5a.webp": 2842,
	"./93f38fd3.webp": 47713,
	"./98fcbb08.webp": 15571,
	"./a1a2bc77.webp": 40933,
	"./abstract-1.webp": 19473,
	"./abstract-10.webp": 10799,
	"./abstract-2.webp": 52756,
	"./abstract-3.webp": 63767,
	"./abstract-4.webp": 48922,
	"./abstract-5.webp": 13093,
	"./abstract-6.webp": 16568,
	"./abstract-7.webp": 71291,
	"./abstract-8.webp": 95982,
	"./abstract-9.webp": 92009,
	"./alice.webp": 78187,
	"./anime.webp": 25923,
	"./aurora-2.webp": 64642,
	"./aurora.webp": 60801,
	"./autumn.webp": 18319,
	"./aviator.webp": 29709,
	"./b909ea37.webp": 51003,
	"./baroque.webp": 50308,
	"./bart.webp": 76858,
	"./beauty.webp": 19057,
	"./bubbles.webp": 81736,
	"./calmness.webp": 34101,
	"./candy.webp": 10422,
	"./canvas.webp": 76593,
	"./capri.webp": 65614,
	"./caribbean.webp": 97476,
	"./carnival.webp": 32143,
	"./ceremony.webp": 64657,
	"./charles.webp": 94991,
	"./coffee.webp": 67809,
	"./colorful.webp": 37727,
	"./comic.webp": 63074,
	"./cordeville.webp": 73180,
	"./crinkle.webp": 80643,
	"./cubism.webp": 31300,
	"./daily.webp": 82422,
	"./dark.webp": 59997,
	"./dawn.webp": 51435,
	"./dd4e344b.webp": 20831,
	"./dd87e344.webp": 92112,
	"./discofever.webp": 37701,
	"./dotty.webp": 36211,
	"./dreamworld.webp": 74852,
	"./eagle.webp": 18339,
	"./elegant-silence.webp": 33271,
	"./elisabeth.webp": 98466,
	"./epoch.webp": 76590,
	"./explosion.webp": 11020,
	"./expressionism.webp": 38670,
	"./eye.webp": 44874,
	"./fairy.webp": 50134,
	"./fantasy.webp": 38093,
	"./feast.webp": 19852,
	"./forelock.webp": 68356,
	"./forward.webp": 2122,
	"./ghibli-studio.webp": 62351,
	"./gothic.webp": 42927,
	"./grace.webp": 25623,
	"./illustration.webp": 67519,
	"./impressionism-1.webp": 92169,
	"./impressionism-2.webp": 14252,
	"./iridescent.webp": 57857,
	"./joke.webp": 37646,
	"./landscape.webp": 92306,
	"./luminous.webp": 45039,
	"./madison.webp": 29748,
	"./manga.webp": 58119,
	"./mediterranean.webp": 87056,
	"./mixture.webp": 47327,
	"./modern-art-1.webp": 57408,
	"./modern-art-2.webp": 31117,
	"./modern-art-3.webp": 75554,
	"./modern-art-4.webp": 56991,
	"./modern-art-5.webp": 78748,
	"./modern-art-6.webp": 58425,
	"./moonlight.webp": 77832,
	"./mosaic-1.webp": 96667,
	"./mosaic-2.webp": 17146,
	"./mosaic-3.webp": 38245,
	"./mudita.webp": 35723,
	"./newspaper.webp": 65572,
	"./ocean.webp": 22065,
	"./oil-painting.webp": 96514,
	"./patterns.webp": 32358,
	"./pencil.webp": 45176,
	"./petals.webp": 90988,
	"./photography.webp": 45268,
	"./pixel-art.webp": 77815,
	"./pointillism-1.webp": 19421,
	"./pointillism-2.webp": 76592,
	"./pointillism-3.webp": 2355,
	"./pop-art.webp": 17888,
	"./pop.webp": 59068,
	"./poppy.webp": 56647,
	"./promenade.webp": 72812,
	"./retro.webp": 47555,
	"./satisfaction.webp": 92917,
	"./sixties.webp": 41796,
	"./sketch-1.webp": 98699,
	"./sketch-2.webp": 96810,
	"./sketch-3.webp": 1077,
	"./sketchy.webp": 84508,
	"./snow.webp": 10066,
	"./summer.webp": 49032,
	"./sunny.webp": 28304,
	"./surrealism-1.webp": 96194,
	"./surrealism-2.webp": 61091,
	"./surrealism-3.webp": 78048,
	"./tears.webp": 50302,
	"./ukiyo-e.webp": 3530,
	"./urban.webp": 86951,
	"./voyage.webp": 32380,
	"./waterbird.webp": 38583,
	"./watercolor-1.webp": 91461,
	"./watercolor-2.webp": 36184,
	"./wolf.webp": 80985,
	"./yira.webp": 54618,
	"./zinaida.webp": 42959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27131;